<div class="parking-type-add-dialog">
    <h2 mat-dialog-title class="flex items-center gap-2">
        <mat-icon class="text-purple-600">add_circle</mat-icon>
        Add Parking Type
    </h2>

    <mat-dialog-content>
        <form [formGroup]="form" class="space-y-4">
            <!-- Parking Type Selection -->
            <mat-form-field appearance="fill" class="w-full">
                <mat-label>Parking Type</mat-label>
                <mat-select formControlName="parkingTypeId" required>
                    @for (type of parkingTypeOptions; track type.id) {
                    <mat-option [value]="type.id">
                        <div class="flex items-center gap-2">
                            <mat-icon class="text-base" [fontIcon]="type.icon"></mat-icon>
                            <div class="flex flex-col">
                                <span>{{ type.name }} </span>
                                <span class="text-xs text-gray-500">{{ type.description }}</span>
                            </div>
                        </div>
                    </mat-option>
                    }
                </mat-select>
                @if (form.get('parkingTypeId')?.hasError('required') && form.get('parkingTypeId')?.touched) {
                <mat-error>Please select a parking type</mat-error>
                }
            </mat-form-field>

            <!-- Dynamic Sub-Component Based on Selection -->
            @switch (selectedType()) {
            @case ('default-exemption') {
            <app-add-default-exemption [parkingSpace]="parkingSpace" [parkingOperatorId]="parkingOperatorId"
                (submitted)="onChildSubmitted($event)">
            </app-add-default-exemption>
            }
            @case ('custom-exemption') {
            <app-add-custom-exemption [parkingSpace]="parkingSpace" [parkingOperatorId]="parkingOperatorId"
                (submitted)="onChildSubmitted($event)">
            </app-add-custom-exemption>
            }
            @case ('assigned-zone-parkers') {
            <app-add-assigned-zone-type [parkingSpace]="parkingSpace" [parkingOperatorId]="parkingOperatorId"
                (submitted)="onChildSubmitted($event)">
            </app-add-assigned-zone-type>
            }
            @case ('pool-parking') {
            <app-add-pool-parking [parkingSpace]="parkingSpace" [parkingOperatorId]="parkingOperatorId"
                (submitted)="onChildSubmitted($event)">
            </app-add-pool-parking>
            }
            @case ('long-term') {
            <app-add-long-term-type [parkingSpace]="parkingSpace" [parkingOperatorId]="parkingOperatorId"
                (submitted)="onChildSubmitted($event)">
            </app-add-long-term-type>
            }
            @case ('short-term') {
            <app-add-short-term-type [parkingSpace]="parkingSpace" [parkingOperatorId]="parkingOperatorId"
                (submitted)="onChildSubmitted($event)">
            </app-add-short-term-type>
            }
            @case ('easypass') {
            <app-add-easypass-type [parkingSpace]="parkingSpace" [parkingOperatorId]="parkingOperatorId"
                (submitted)="onChildSubmitted($event)">
            </app-add-easypass-type>
            }
            }

            <!-- Info Box when no type selected -->
            @if (!selectedType()) {
            <div class="bg-blue-50 border border-blue-200 rounded-lg p-4">
                <div class="flex items-start gap-2">
                    <mat-icon class="text-blue-600 text-sm">info</mat-icon>
                    <div class="text-sm text-blue-800">
                        <p class="font-medium mb-1">About Parking Types</p>
                        <ul class="list-disc list-inside text-blue-700 space-y-1">
                            <li><strong>Default Exemption:</strong> Exempt vehicles matching a regex pattern</li>
                            <li><strong>Custom Exemption:</strong> Exempt specific license plates</li>
                            <li><strong>Assigned Zone Parkers:</strong> Assign parkers to specific zones</li>
                            <li><strong>Pool Parking:</strong> Link to an organization pool parking configuration</li>
                            <li><strong>Long-Term:</strong> Long-term parkers with extended access</li>
                            <li><strong>Short-Term:</strong> Visitors admitted and billed per the short-term tariff</li>
                        </ul>
                    </div>
                </div>
            </div>
            }
        </form>
    </mat-dialog-content>

    <mat-dialog-actions align="end" class="gap-2">
        <jjames-button [variant]="'secondary'" (clicked)="onCancel()">
            Cancel
        </jjames-button>
        <jjames-button [variant]="'primary'" (clicked)="onSubmit()" [disabled]="!selectedType() || isLoading()"
            matIconLeft="add">
            @if (isLoading()) {
            Adding...
            } @else {
            Add Type
            }
        </jjames-button>
    </mat-dialog-actions>
</div>